<template>
    <div class="reply-add-or-update">
        <el-dialog
            :title="autoReplyQuery.id ? '修改回复' : '添加回复'"
            :close-on-click-modal="false"
            :visible.sync="replyDialog"
        >
            <el-form
                label-width="100px"
                :rules="relayRules"
                ref="keywordRef"
                :model="autoReplyQuery"
            >
                <el-form-item label="关键词:" prop="keyword">
                    <el-input
                        v-model="autoReplyQuery.keyword"
                        placeholder="请输入关键词"
                    ></el-input>
                </el-form-item>
                <el-form-item label="回复模式:">
                    <el-radio-group
                        v-model="autoReplyQuery.msgType"
                        size="small"
                        @change="msgTypeChange"
                    >
                        <el-radio-button label="text">文本回复</el-radio-button>
                        <el-radio-button label="news">图文回复</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="图片标题"
                    v-if="autoReplyQuery.msgType === 'news'"
                >
                    <el-input
                        placeholder="请输入图片标题"
                        v-model="imgText_info.title"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="图片描述"
                    v-if="autoReplyQuery.msgType === 'news'"
                >
                    <el-input
                        placeholder="请输入图片描述"
                        v-model="imgText_info.description"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="跳转链接"
                    v-if="autoReplyQuery.msgType === 'news'"
                >
                    <el-input
                        placeholder="请输入跳转链接"
                        v-model="imgText_info.url"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="回复图片:"
                    v-if="autoReplyQuery.msgType === 'news'"
                >
                    <el-upload
                        ref="upload"
                        :action="uploadUrl"
                        :class="imgText_info.picUrl ? 'upload' : ''"
                        name="file"
                        accept=".png,.jpg"
                        :on-preview="handlePreview"
                        :before-upload="beforeUpload"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        :on-remove="handleRemove"
                        list-type="picture-card"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="回复内容:" v-else>
                    <!-- <add-or-update-editor @editorChange="editorChange" /> -->
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        v-model="replyContent"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitClick"
                        >确认</el-button
                    >
                    <el-button @click="replyDialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
// import addOrUpdateEditor from "@/views/modules/config/child-components/add-or-update-editor.vue";
// import cloneDeep from "lodash/cloneDeep";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
export default {
    // components: { addOrUpdateEditor },
    data() {
        return {
            replyDialog: false,
            // 添加关键词回复的参数
            autoReplyQuery: {
                keyword: "",
                content: "",
                type: "1",
                id: null,
                msgType: "text",
            },
            // 图文模式的参数
            imgText_info: {
                title: "",
                picUrl: "",
                description: "",
                url: "",
            },
            // 纯文本模式参数
            replyContent: "",
            relayRules: {
                keyword: [
                    {
                        required: true,
                        message: "请输入关键词",
                        trigger: "blur",
                    },
                ],
            },
            // 上传图片的路径
            uploadUrl: "",
            // 图片预览的对话框显示与隐藏
            dialogVisible: false,
            // 图片预览路径
            dialogImageUrl: "",
            fileList: [],
        };
    },
    created() {
        this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
    },
    methods: {
        // 初始化打开对话框
        init(id) {
            this.autoReplyQuery.id = id || 0;
            this.replyDialog = true;
            if (this.autoReplyQuery.id) {
                this.getDetailInfo();
            }
        },
        // 富文本内容变化时传递的回调函数
        // editorChange(val) {
        //     this.autoReplyQuery.content = val;
        // },
        // 点击确认按钮提交表单
        submitClick() {
            this.$refs.keywordRef.validate((valid) => {
                if (valid) {
                    // 判断当前的模式，给content赋值
                    if (this.autoReplyQuery.msgType === "text") {
                        this.autoReplyQuery.content = this.replyContent;
                    } else {
                        this.autoReplyQuery.content = JSON.stringify(
                            this.imgText_info
                        );
                    }
                    // 判断参数id是否为0，如果为0，置为null
                    this.autoReplyQuery.id === 0
                        ? (this.autoReplyQuery.id = null)
                        : null;
                    this.$ajaxPost(
                        `/wxMsg/${
                            this.autoReplyQuery.id ? "update" : "save"
                        }/open`,
                        this.autoReplyQuery
                    ).then(({ data }) => {
                        if (data.code === 0) {
                            this.replyDialog = false;
                            this.$emit("succeedAction");
                            this.$message.success("操作成功！");
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 获取详细回复信息
        getDetailInfo() {
            this.$ajaxGet("/wxMsg/info/" + this.autoReplyQuery.id, {}).then(
                ({ data }) => {
                    if (data.code === 0) {
                        if (data.data.msgType === "text") {
                            this.replyContent = data.data.content;
                        } else {
                            this.imgText_info = JSON.parse(showcontent(data.data.content));

                            this.fileList = [{name: '回复图片', url: this.imgText_info.picUrl}]
                        }
                        Object.keys(this.autoReplyQuery).forEach((item) => {
                            this.autoReplyQuery[item] = data.data[item];
                        });
                    }
                }
            );
        },
        // 模式绑定值变化时触发函数
        msgTypeChange(val) {
            // 字符模式把字符串放在content里，图文模式把json对象的字符串放在content里
            if (val === "news") {
                this.autoReplyQuery.msgType = val;
            } else {
                this.autoReplyQuery.msgType = val;
            }
        },
        // ==============图片上传相关方法=========
        // 从本地保存的上传目录中删除图片路径
        handleRemove(file, fileList) {
            this.imgText_info.picUrl = "";
        },
        handlePreview(file) {
            // window.open(file.url, "_blank").location;
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$message.error("上传文件大小不能超过 10MB!");
            }
            return isLt100M;
        },
        handleSuccess(response) {
            if (response && response.code === 0) {
                console.log(response);
                console.log("文件上传成功返回结果：", response.data);
				let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
                this.imgText_info.picUrl = url;
            }
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .w-e-toolbar {
    display: none;
}
/deep/ .w-e-text-container {
    height: 100px !important;
    border: 1px solid #c0c4cc !important;
    .w-e-text {
        min-height: 100px;
    }
}

/deep/ .upload {
    .el-upload--picture-card {
        display: none !important;
    }
}
</style>